<div class="vae-page vae-list-page">
  <span class="development-ribbon">En desarrollo</span>
    <app-table-surface
      tableId="spiritual-assistance-visits-list"
      title="Visitas registradas"
      titleIcon="volunteer_activism"
      [columns]="columns"
      [data]="filteredVisits"
      [isLoading]="loading"
      [errorMessage]="errorMessage"
      noDataMessage="No hay VAE que coincidan con los filtros seleccionados."
      [tableHeight]="'auto'"
      [enableRowHover]="false"
      [enableHeaderSort]="true"
      [initialSort]="sortState"
      [enableSearch]="true"
      searchPlaceholder="Buscar visitas..."
      [enableFilter]="true"
      [enableSort]="true"
      [sortState]="sortState"
      [enableColumnVisibility]="true"
      [enableDensity]="true"
      [cellTemplate]="visitCell"
      [activeFilters]="activeFilterChips"
      [primaryActionLabel]="user.hasPermission('ManageSpiritualAssistanceVisits') ? 'Nuevo' : undefined"
      (searchChange)="onToolbarSearch($event)"
      (filterRemove)="onFilterRemove($event)"
      (toolbarSortChange)="onToolbarSort($event)"
      (sortChange)="onToolbarSort($event)"
      (primaryActionClick)="create()">
      <div filterPanel class="vae-quick-filters" [formGroup]="filterForm">
        <div class="filter-row filter-row--search">
          <app-date-range-picker class="date-range-field" label="Fecha" startPlaceholder="DD/MM/AAAA" endPlaceholder="DD/MM/AAAA" [formGroup]="filterForm.controls.dateRange"></app-date-range-picker>
          <app-data-table-multi-select-filter formControlName="recipient" label="Miembro" [options]="recipientOptions"></app-data-table-multi-select-filter>
          <app-person-multi-select-filter formControlName="visitor" label="Asistente espiritual" [searchPeople]="searchVisitors" (selectedPeopleChange)="onVisitorSelectionChange($event)"></app-person-multi-select-filter>
          <app-spiritual-assistance-visit-responsible-priest-filter formControlName="responsiblePriest" [pastors]="responsiblePriestOptions"></app-spiritual-assistance-visit-responsible-priest-filter>
          <button mat-button type="button" class="vae-more-filters" [class.vae-more-filters--active]="hasAdvancedFilters" (click)="openMoreFilters()">
            <mat-icon>tune</mat-icon>
            Más filtros
          </button>
        </div>
      </div>
    </app-table-surface>

  <ng-template #visitCell let-column="column" let-visit="row">
    <ng-container [ngSwitch]="column">
      <span *ngSwitchCase="'visitDate'" class="vae-date-cell">{{ formatDate(visit.visitDate) }}</span>
      <span *ngSwitchCase="'recipients'" class="vae-people-cell" [attr.title]="formatPeople(visit.recipients)">
        <ng-container *ngFor="let person of visit.recipients; let last = last">
          <a class="vae-entity-link" [routerLink]="['/people', person.id]">{{ person.fullName }}</a><span *ngIf="!last">, </span>
        </ng-container>
      </span>
      <span *ngSwitchCase="'responsiblePriests'" class="vae-people-cell" [attr.title]="formatResponsiblePriests(visit)">
        <ng-container *ngIf="getResponsiblePriests(visit).length; else noResponsiblePriest">
          <ng-container *ngFor="let person of getResponsiblePriests(visit); let last = last">
            <a class="vae-entity-link" [routerLink]="['/people', person.id]">{{ person.fullName }}</a><span *ngIf="!last">, </span>
          </ng-container>
        </ng-container>
        <ng-template #noResponsiblePriest>-</ng-template>
      </span>
      <a *ngSwitchCase="'community'" class="vae-entity-link vae-community-cell" [routerLink]="['/units', visit.organizationUnitId]">{{ visit.organizationUnitName }}</a>
      <span *ngSwitchCase="'visitors'" class="vae-people-cell" [attr.title]="formatPeople(visit.visitors)">
        <ng-container *ngFor="let person of visit.visitors; let last = last">
          <a class="vae-entity-link" [routerLink]="['/people', person.id]">{{ person.fullName }}</a><span *ngIf="!last">, </span>
        </ng-container>
      </span>
      <span *ngSwitchCase="'location'" class="vae-location-cell">{{ getLocation(visit) }}</span>
      <span *ngSwitchCase="'communion'" class="vae-communion-badge" [class.vae-communion-badge--delivered]="visit.holyCommunionDelivered">{{ visit.holyCommunionDelivered ? 'Sí' : 'No' }}</span>
      <div *ngSwitchCase="'actions'" class="vae-actions-cell">
        <button mat-icon-button type="button" matTooltip="Editar VAE" aria-label="Editar VAE" (click)="$event.stopPropagation(); edit(visit)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button type="button" color="warn" matTooltip="Eliminar VAE" aria-label="Eliminar VAE" (click)="$event.stopPropagation(); delete(visit)"><mat-icon>delete_outline</mat-icon></button>
      </div>
    </ng-container>
  </ng-template>
</div>
